import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './vos.scss';

interface FullVosImageProps {
    onClickShow: () => void;
    onClickHide: () => void;
    show: boolean;
    image: string;
    imageName: string;
}

const FullVosImage = ({ onClickHide, show, image, imageName }: FullVosImageProps): React.ReactElement => {
    return (
        <Modal size="lg" show={show} onHide={onClickHide}>
            <Modal.Header closeButton>
                <Modal.Title>{imageName}</Modal.Title>
            </Modal.Header>
            <img className="JobImage-Full" src={image} onClick={onClickHide} alt="" />
        </Modal>
    );
};

export default FullVosImage;

